import { render } from "./EmpJobTitlesPage.vue?vue&type=template&id=c24c67d2"
import script from "./EmpJobTitlesPage.vue?vue&type=script&lang=js"
export * from "./EmpJobTitlesPage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\abbas\\Desktop\\kswc\\kswc_dashboard-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__